import { useState, useEffect} from 'react';
import axios from 'axios';
import API_URL from "../../src/Config";
import "./ForgotPassword.css"
import { useNavigate } from "react-router-dom";
import axiosInstance from "../axiosinstance";
import { FiEye, FiEyeOff } from 'react-icons/fi';

export default function ForgotPassword() {
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState('');
  const [otp, setOtp] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [message, setMessage] = useState('');
  const [loading,setLoading]=useState(false)
  const [resendCooldown,setResendCooldown] = useState(0)
   const navigate = useNavigate();

  const sendOtp = async () => {
    setLoading(true)
    try {
      const res = await axiosInstance.post(`${API_URL}/auth/forget_password`, { email });
      setMessage(res.data.message);
      setStep(2);
    } catch (err) {
      const errorInMail = err.response?.data?.message || 'Invalid Email or failed to send Mail.'
      setMessage(errorInMail);
    }finally {
    setLoading(false);
  }

  };

 const verifyOtpAndResetPassword = async () => {
  try {
    const res = await axiosInstance.post(`${API_URL}/auth/verify_otp_and_reset_password`, {
      email,
      otp,
      new_password: newPassword
    });

    setMessage(res.data.message);
    console.log("Password reset successful");
    setStep(3); // Optional: show success message or redirect
  } catch (err) {
    const errorMessage =
    err.response?.data?.message || 'Invalid OTP or failed to reset password.';
    setMessage(errorMessage);
    console.log("OTP verification failed:", errorMessage);
  }
};


  const resendOtp = async () => {
    try {
      const res = await axiosInstance.post(`${API_URL}/auth/resend_otp`, {
        email,
      });
      setMessage(res.data.message);
      setResendCooldown(30)
    } catch (err){
      const errorInResend = err.response?.data?.message || 'Invalid Email or failed to Resend Mail.'
      setMessage(errorInResend);
    }
  };

 useEffect(() => {
  if (resendCooldown > 0) {
    const timer = setTimeout(() => setResendCooldown(resendCooldown - 1), 1000);
    return () => clearTimeout(timer);
  }
}, [resendCooldown]);

  return (
    <div className="forgot-password-container">
  <img
    src="/jecon.png"
    alt="JECON Taros"
    className="forgot-password-logo"
  />
  <h2>Forgot Password</h2>
  {/* <p>{message}</p> */}

  {step === 1 && (
    <>
      <input
        id="reset-email"
        name="reset-email"
        type="email"
        placeholder="Enter your email"
        autoComplete="off"
        value={email}
        onChange={e => setEmail(e.target.value)}
      />
        <button onClick={sendOtp}>
          { loading ? (<span className="loader"></span>) : (' Send OTP')
          }
         </button>
    </>
  )}

  {step === 2 && (
  <>
    <input
      id="reset-otp"
      name="reset-otp"
      type="text"
      placeholder="Enter OTP"
      autoComplete="one-time-code"
      value={otp}
      onChange={e => setOtp(e.target.value)}
    />
    <div className="password-input-container">
      <input
        id="reset-new-password"
        name="reset-new-password"
        type={showPassword ? "text" : "password"}
        placeholder="Enter new password"
        autoComplete="new-password"
        value={newPassword}
        onChange={e => setNewPassword(e.target.value)}
      />
      <span 
        className="password-toggle-icon"
        onClick={() => setShowPassword(!showPassword)}
      >
        {showPassword ? <FiEyeOff /> : <FiEye />}
      </span>
    </div>
  
     <button onClick={resendOtp} style={{  }}>
        {resendCooldown > 0 ? `Resend OTP in ${resendCooldown}s` : 'Resend OTP'}
    </button>
      <button onClick={verifyOtpAndResetPassword} style={{marginTop:'10px'  }}>Submit</button>
    {message && <p style={{ color: 'red' ,marginTop:'10px'  }}>{message}</p>}
  </>
)}

  {step === 3 && (
    <>
      <p style={{ color: 'green' ,marginTop:'10px'  }}>Password has been reset successfully. You can now log in.</p>
      <button onClick={() => navigate("/login")} style={{marginTop:'10px'  }}>Login</button>
      
    </>
  )}
</div>

  );
}
